import { BaseController } from "./BaseController";
import TaskTemplate from "../types/TaskTemplate";

export class TaskController extends BaseController<TaskTemplate> {
  constructor() {
    super("taskTemplates", "TaskControllerDBCounters");
  }
}
